import type { Map } from 'maplibre-gl';

/**
 * Mapping user-level (1..12) ↔ MapLibre zoom (ML).
 * Mirrors frontend/src/app/map/zoomLevels.ts.
 *
 *   12 → 100 km  |  6 → 2 km
 *   11 → 50 km   |  5 → 1 km
 *   10 → 30 km   |  4 → 500 m
 *    9 → 20 km   |  3 → 300 m
 *    8 → 10 km   |  2 → 100 m
 *    7 → 5 km    |  1 → 50 m
 */
const LEVEL_TO_ML: Record<number, number> = {
  12: 5.3,
  11: 6.3,
  10: 7.0,
  9: 7.6,
  8: 8.6,
  7: 9.6,
  6: 10.9,
  5: 11.9,
  4: 12.9,
  3: 13.9,
  2: 15.0,
  1: 16.0,
};

const LEVEL_THRESHOLDS: Array<[number, number]> = [
  [5.8, 12],
  [6.6, 11],
  [7.3, 10],
  [8.1, 9],
  [9.1, 8],
  [10.2, 7],
  [11.4, 6],
  [12.4, 5],
  [13.4, 4],
  [14.4, 3],
  [15.5, 2],
];

export function userLevelFromMap(map: Map): number {
  const ml = map.getZoom();
  for (const [threshold, level] of LEVEL_THRESHOLDS) {
    if (ml < threshold) return level;
  }
  return 1;
}

export function mlForUserLevel(_map: Map, level: number): number {
  return LEVEL_TO_ML[level] ?? 10;
}
